import { fontSize } from "./variables";

export const anchorReset = `
    color: inherit;
    text-decoration: none;
    -webkit-appearance: none;
`;

export const buttonReset = `
    box-shadow: none;
    background: transparent;
    border: none;
    color: inherit;
    cursor: pointer;
    font-family: inherit;
    outline: none;
    padding: 0;
    -webkit-appearance: none;
    ${fontSize};
`